module.exports = [{
      plugin: require('/tmp/ac476b9/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#ebfefe","theme_color":"#ebfefe","display":"minimal-ui","icon":"src/images/favicon.png"},
    },{
      plugin: require('/tmp/ac476b9/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
